import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
import Counter from '../../NumCounter.js'
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Microlaryngeal Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get precise Microlaryngeal Surgery in Delhi, India for voice and throat disorders. Learn about treatment, procedure, and surgery cost." />
            <meta name="keywords" content="microlaryngeal surgery Delhi, vocal cord microsurgery, 
Microlaryngeal surgery,Microlaryngeal surgery complications,Microlaryngeal surgery cost,Microlaryngeal surgery anesthesia, larynx surgery" />
            <link rel="canonical" href="https://entdelhi.com/microlaryngeal-surgery/" />
            <meta property="og:title" content="Microlaryngeal Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get precise Microlaryngeal Surgery in Delhi, India for voice and throat disorders. Learn about treatment, procedure, and surgery cost." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         <GetInTouch/>
      </main>
    </div>
  )
}
